import { AuthPageLayout as AuthPageLayoutLib } from '@round/auth';
import backgroundImage from './AuthPageBackground.png';
import { ReactComponent as Logo } from '../../../../assets/ApexLogo.svg';
import React from 'react';
import styles from './AuthPageLayout.module.css';
import { FCWithChildren } from '../../../../utils/utils.types';

const AuthPageLayout: FCWithChildren = ({ children }) => (
    <AuthPageLayoutLib LogoFull={() => <Logo className={styles.logoFull} />} brandingImageSrc={backgroundImage}>
        {children}
    </AuthPageLayoutLib>
);

export default AuthPageLayout;
